import React from "react"
import LayoutTwo from "../../components/LayoutTwo"
import { graphql } from "gatsby"
import Image from "gatsby-image"
import AllRealstates from "../../components/AllRealEstates"
import SEO from "../../components/SEO"
import { useLanguage } from "../../contexts/LanguageContext"

const RealEstates = ({
  data: {
    file: {
      childImageSharp: { fluid },
    },
  },
}) => {
  const { selectedLanguage } = useLanguage() // Use the useLanguage hook
  return (
    <LayoutTwo>
      <SEO title="Nekretnine" />
      <div className="img-wrapper img-wrapper-about">
        <Image Tag="div" fluid={fluid} className=" bcg bcg-about  " />
        {selectedLanguage === "EN" ? (
          <div>
            <h2 className="about-header visibility-filter ">
              Real estate for sale
            </h2>
            <h2 className="about-header mobile-visible">Real estate</h2>
          </div>
        ) : (
          <div>
            <h2 className="about-header visibility-filter ">
              Nekretnine na prodaju
            </h2>
            <h2 className="about-header mobile-visible">Nekretnine</h2>
          </div>
        )}
      </div>
      <AllRealstates />
    </LayoutTwo>
  )
}

export const query = graphql`
  {
    file(relativePath: { eq: "pexels-mitchell-luo-3694708.jpg" }) {
      childImageSharp {
        fluid(
          sizes: "(max-width: 300px) calc(100vw - 25px), (max-width: 600px) calc(100vw - 15px), 1300px"
        ) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
export default RealEstates
